export default __webpack_public_path__ + "static/media/shirt.9660f6ef.png";